import { Commit } from 'vuex';
import { MonCompteState } from '@/modules/MonCompte/store/state';

export interface MonCompteModuleActionTypes {
    commit: Commit,
    state: MonCompteState,
    getters: any
}

export enum MonCompteModuleAction {
    LOAD_INFORMATIONS = 'LOAD_INFORMATIONS',
    SAVE_MOBILE_PHONE = 'SAVE_MOBILE_PHONE',
    SAVE_PHONE = 'SAVE_PHONE',
    SAUVEGARDER_MDP = 'SAUVEGARDER_MDP',
    DEMANDER_SUPPRESSION_COMPTE= 'DEMANDER_SUPPRESSION_COMPTE',
    LOAD_DELETE_ACCOUNT_REQUESTED = 'LOAD_DELETE_ACCOUNT_REQUESTED'

}
